import React from 'react';

export type FlussoCommerciale = 'VENDITA' | 'APPALTO_CONTRATTO';

interface Props {
  flusso: FlussoCommerciale | null | undefined;
  compatto?: boolean; // true per uso in elenchi (solo icona + sigla)
}

const ETICHETTE: Record<FlussoCommerciale, { label: string; sigla: string; icona: string }> = {
  VENDITA: { label: 'Vendita', sigla: 'Ven', icona: '📦' },
  APPALTO_CONTRATTO: { label: 'Appalto/Contratto', sigla: 'App', icona: '🏗️' },
};

const BadgeFlussoCommerciale: React.FC<Props> = ({ flusso, compatto = false }) => {
  if (!flusso) return null;
  const meta = ETICHETTE[flusso];
  if (!meta) return null;

  const modifierFlusso =
    flusso === 'VENDITA' ? 'bop-badge-flusso--vendita' : 'bop-badge-flusso--appalto';
  const modifierCompatto = compatto ? 'bop-badge-flusso--compatto' : '';

  return (
    <span
      className={`bop-badge-flusso ${modifierFlusso} ${modifierCompatto}`.trim()}
      title={`Flusso commerciale: ${meta.label}`}
    >
      <span className="bop-badge-flusso__icona" aria-hidden="true">{meta.icona}</span>
      <span className="bop-badge-flusso__label">{compatto ? meta.sigla : meta.label}</span>
    </span>
  );
};

export default BadgeFlussoCommerciale;
export { BadgeFlussoCommerciale };
